import posthog from "posthog-js";
import { readConsent } from "./consentManager";
import { getStoredMarketingContext } from "./marketing";

/**
 * Fire a tracking event via the main posthog instance.
 * Safe to call before consent / posthog load — silently no-ops.
 *
 * Auto-injects the stored marketing context (utm_*, email) onto every event
 * so downstream queries can filter by event properties without depending on
 * person-level $initial_utm_* attribution. Caller-supplied props win on key
 * conflicts.
 */
export function trackCta(event, props = {}) {
  const consent = readConsent();
  if (!consent?.analytics) return;
  if (typeof window === "undefined" || !window._posthogLoaded) return;

  try {
    const marketing = getStoredMarketingContext();
    posthog.capture(event, {
      location: window.location.pathname,
      ...marketing,
      ...props,
    });
  } catch {}
}
